import { WordRect } from '@ps-gui/claims-terminal-shared';
import { maxBy, minBy } from '@ps-gui/shared-utils';

export const getUnionRect = (wordRects: WordRect[]): WordRect => {
  if (wordRects.length === 0) {
    throw new Error('Value cannot be undefined or null');
  }

  const x0 = minBy(wordRects, (wordRect) => wordRect.x[0])!.x[0];
  const x1 = maxBy(wordRects, (wordRect) => wordRect.x[1])!.x[1];
  const y0 = minBy(wordRects, (wordRect) => wordRect.y[0])!.y[0];
  const y1 = maxBy(wordRects, (wordRect) => wordRect.y[1])!.y[1];

  return {
    x: [x0, x1],
    y: [y0, y1],
  };
};

/**
 * Since we cannot represent an "empty set" with a word rect, we return undefined
 * in case the intersection is empty.
 */
export const getIntersectionRect = (wordRects: WordRect[]): WordRect | undefined => {
  if (wordRects.length === 0) return undefined;

  const x0 = maxBy(wordRects, (wordRect) => wordRect.x[0])!.x[0];
  const x1 = minBy(wordRects, (wordRect) => wordRect.x[1])!.x[1];
  const y0 = maxBy(wordRects, (wordRect) => wordRect.y[0])!.y[0];
  const y1 = minBy(wordRects, (wordRect) => wordRect.y[1])!.y[1];

  if (x0 > x1 || y0 > y1) return undefined;

  return {
    x: [x0, x1],
    y: [y0, y1],
  };
};
